export default __webpack_public_path__ + "static/media/section2-img3-mob.d17dd7c9.png";